import React from "react";

const STYLES = {
  DRAFT: "bg-slate-100 text-slate-700 border-slate-300",
  DIPERIKSA: "bg-amber-50 text-amber-700 border-amber-200",
  FINAL: "bg-blue-50 text-blue-700 border-blue-200",
  DIBAYAR: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "SUDAH DIBAYAR": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "BELUM DIBAYAR": "bg-slate-100 text-slate-600 border-slate-300",
  Aktif: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Nonaktif: "bg-slate-100 text-slate-600 border-slate-300",
  Lunas: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Dipotong Sebagian": "bg-amber-50 text-amber-700 border-amber-200",
  "Belum Dipotong": "bg-slate-100 text-slate-600 border-slate-300",
};

const DOTS = {
  DRAFT: "bg-slate-400", DIPERIKSA: "bg-amber-500", FINAL: "bg-blue-600",
  DIBAYAR: "bg-emerald-500", "SUDAH DIBAYAR": "bg-emerald-500", "BELUM DIBAYAR": "bg-slate-400",
};

export default function StatusBadge({ status, testid }) {
  const cls = STYLES[status] || "bg-slate-100 text-slate-700 border-slate-300";
  const dot = DOTS[status];
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}
    >
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />}
      {status}
    </span>
  );
}
